import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const News = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // _embed is required to get the category names
        const res = await axios.get("https://cms.nausurology.org/wp-json/wp/v2/posts?_embed");
        setPosts(res.data);
      } catch (err) {
        console.error("Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <div style={{ padding: '100px', textAlign: 'center', color: 'var(--primary-green)' }}>Loading Categories...</div>;

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '36px', fontWeight: '900', color: 'var(--dark-gray)', marginBottom: '40px' }}>
        NAUS <span style={{ color: 'var(--primary-green)' }}>Archive</span>
      </h1>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
        gap: '30px' 
      }}>
        {posts.map((post) => {
          const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
          // Get the first category name
          const categoryName = post._embedded?.['wp:term']?.[0]?.[0]?.name || "Uncategorized";

          return (
            <div key={post.id} className="card-featured" style={{
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'column',
              position: 'relative'
            }}>
              
              {/* Category Badge */}
              <div style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                backgroundColor: 'var(--medical-gold)',
                color: 'white',
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '10px',
                fontWeight: 'bold',
                zIndex: 10,
                textTransform: 'uppercase'
              }}>
                {categoryName}
              </div>

              {/* Image Container */}
              <div style={{ height: '220px', backgroundColor: '#f4f4f4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {imageUrl ? (
                  <img src={imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '10px' }} />
                ) : (
                  <div style={{ color: '#ccc', fontWeight: 'bold' }}>NAUS MEDIA</div>
                )}
              </div>

              {/* Content */}
              <div style={{ padding: '25px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--dark-green)', marginBottom: '10px' }} 
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                
                <div style={{ fontSize: '14px', color: 'var(--secondary-gray)', marginBottom: '20px', lineHeight: '1.6' }} 
                     dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />

                <Link className="link-underlined" to={`/news/${post.slug}`} style={{ 
                  marginTop: 'auto', 
                  fontWeight: '800', 
                  fontSize: '12px', 
                  textTransform: 'uppercase' 
                }}>
                  View Full Article →
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default News;